function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as x } from "react/jsx-runtime";
import { useFieldProps as M } from "./form-context.js";
import { useTheme as g } from "./hooks.js";
import { TextFieldBaseAutosuggest as y } from "./text-field-base.js";
const A = /^[^\s@]+@[^\s@]+\.[^\s@]+$/, I = (_param)=>{
    var { disabled: o , error: i , helperText: m , name: n , optional: s , validate: r , onChange: l , onChangeValue: f , onBlur: u , value: c , autoComplete: a = "email" , defaultValue: d  } = _param, E = _object_without_properties(_param, [
        "disabled",
        "error",
        "helperText",
        "name",
        "optional",
        "validate",
        "onChange",
        "onChangeValue",
        "onBlur",
        "value",
        "autoComplete",
        "defaultValue"
    ]);
    const { texts: t  } = g(), p = M({
        name: n,
        value: c,
        defaultValue: d,
        processValue: (e)=>e.trim(),
        helperText: m,
        optional: s,
        error: i,
        disabled: o,
        onBlur: u,
        validate: (e, F)=>e ? A.test(e) ? r == null ? void 0 : r(e, F) : t.formEmailError : s ? "" : t.formFieldErrorIsMandatory,
        onChange: l,
        onChangeValue: f
    });
    return /* @__PURE__ */ x(y, _object_spread_props(_object_spread({}, E, p), {
        type: "email",
        inputMode: "email",
        autoComplete: a
    }));
}, L = I;
export { L as default };
